import React from "react";

import { merchantPermissionSet } from "helpers";
import { useMerchantSearchQuery } from "queries";

import { merchantResultItem } from "../resultItems";

import MerchantIcon from "static/images/merchant-info.png";

const merchantSection = () => {
	return {
		name: "merchants",
		title: "Merchant Info",
		useSearchQuery: useMerchantSearchQuery,
		renderItem: merchantResultItem,
		getIcon: () => <img src={MerchantIcon} alt="" />,
		getLink: ({ id }) => `/merchant/list/info/${id}/general`,
		requiredPermissions: merchantPermissionSet,
	};
};

export default merchantSection;
